module.exports = function (storePickerService, moveFocus, $rootScope, shopperService, addressService, deliveryService, bwsNotificationService, settingsService) {
    return {
        restrict: 'E',
        scope: {
            wizzardStep: '@',
            timeTable: '=',
            nextDeliveryEta: '=',
            nextDeliveryEtaTime: '=',
            isModifying: '=?',
            defaultSelection: '=?',
            deliveryStore: '=?',
            modifyingBookingRef: '=?',
            orderNo: '=?',
            closePopup: '&?',
            hasPreOrderProduct: '<',
            preOrderMarketReleaseDate: '<',
            preOrderItemRemoved: '<',
            idVerificationChange: '<'
        },
        link(scope) {
            scope.addressService = addressService;
            scope.deliveryService = deliveryService;
            scope.storePicker = storePickerService;
            scope.selectedDate = {};
            scope.showAllDates = true;
            scope.showAlltimes = false;
            scope.savingDeliveryTimes = false;
            scope.deliveryGuaranteeNewMessageFeatureFlag = false;
            scope.deliveryGuaranteeOrNextFreeText = '';
            scope.dateToday = new Date();
            scope.dateTomorrow = new Date();
            scope.dateTomorrow.setDate(scope.dateToday.getDate() + 1);
            scope.deliveryStore = scope.isModifying.mode
                                  ? scope.deliveryStore
                : storePickerService.fulfilmentInfo.DeliveryDetails.FulfilmentStoreName;
            scope.showSchedule = true;

            settingsService.getSettingValue('MobileApp', 'EnableDeliveryGuaranteeFeature').then((value) => {
                scope.deliveryGuaranteeNewMessageFeatureFlag = value || false;
            });
            settingsService.getSettingValue('MobileApp', 'NewDeliveryGuaranteeBusyText').then(function (msg) { scope.deliveryGuaranteeOrNextFreeText = msg; });
            settingsService.getSettingValue('DeliveryWindows', 'DeliveryWindowUserMessage')
                .then(function (value) {
                    scope.deliveryWindowUserMessage = value;
                });

            function shouldUpdate(i) {
                scope.windowData.selectedOption.windowDate = scope.windowData.windowDate[i].window;
                scope.selectedDate.window = scope.windowData.windowDate[i].window;

                scope.windowData.windowTimesToDisplay = scope.windowData.windowTime[i];

            }

            scope.select = function (option) {

                if (option.IsActive === false) {
                    return;
                }

                scope.windowData.selectedOption.windowTime = option;

            };

            scope.openTnC = function () {
                window.open('https://bws.com.au/help/terms-and-conditions');
            };

            /**
             * Update window times based on the selected window date
             * @param i - the index of the array of window ranges or times
             * @param dir - the direction eg. 'nextDay' or 'prevDay'
             */
            scope.updateWindowTimes = function (i, dir) {
                scope.disablePrev = false;
                scope.disableNext = false;
                if (!scope.showAllDates) {
                    if (dir === 'nextDay' && (i + 1) < scope.windowData.windowDate.length) {
                        i = i + 1;
                        shouldUpdate(i);
                    } else if (dir === 'prevDay' && i >= 0) {
                        if (i === 0) {
                            scope.disablePrev = true;
                        } else {
                            i = i - 1;
                            shouldUpdate(i);
                        }
                    } else {
                        scope.disableNext = true;
                    }
                } else {
                    scope.showAllDates = false;
                    scope.showAlltimes = true;
                    shouldUpdate(i);
                }
            };

            function loadTimeTable() {

                scope.windowData = {
                    selectedOption: {
                        windowDate: null,
                        windowTime: null,
                        deliveryType: null
                    },
                    windowDate: [],
                    windowTime: []
                };

                if (scope.defaultSelection.deliveryType) {
                    scope.windowData.selectedOption = scope.defaultSelection;
                }
                //Open the delivery windows by default when opening because the ASAP option is hidden
                if (scope.isModifying.mode) {
                    scope.windowData.selectedOption.deliveryType = 'DateTime';
                }
                scope.showSchedule = scope.timeTable.length > 0;

                angular.forEach(scope.timeTable, function (window, i) {
                    //Get the next available window from the array

                    if (i === 0 && deliveryService.hideAsapOption) {
                        scope.firstAvailableWindow = {
                            windowDate: window.WindowDate,
                            windowTime: window.WindowTimings.length ? window.WindowTimings[0] : window.WindowRanges[0],
                            deliveryType: 'DateTime'
                        };

                        const nextDeliveryDate = new Date(window.WindowDate).getDate();

                        if (nextDeliveryDate === scope.dateToday.getDate()) {
                            scope.nextWindowDateText = 'today';
                        } else if (nextDeliveryDate === scope.dateTomorrow.getDate()) {
                            scope.nextWindowDateText = 'tomorrow';
                        }
                    }

                    scope.windowData.windowDate.push({ window: window.WindowDate });
                    scope.windowData.windowTime.push(window.WindowTimings.length ? window.WindowTimings : window.WindowRanges);
                });

            }

            function _handleSavedDeliveryTimes(res, dto) {
                if (res.Success || res.Status === 'Success') {
                    scope.savingDeliveryTimes = false;

                    deliveryService.selectedDeliveryDateAndTime = dto;
                    $rootScope.$broadcast('delivery-window:selectTime');
                    const data = {
                        event: scope.isModifying.mode ? 'BWSAUmodifyDeliveryTypeAndDateTime' : 'BWSAUsetDeliveryTypeAndDateTime',
                        area: scope.isModifying.mode ? 'Order history' : 'Checkout - Step 1',
                        orderNo: scope.orderNo
                    };
                    deliveryService.sendAnalyticsForDeliveryType(data);
                    if (scope.isModifying.mode) {
                        scope.closePopup();
                        bwsNotificationService.success('Success! Your booking has been updated');
                    }
                }
            }

            function _handleErrorDeliveryTimes() {
                if (scope.isModifying.mode) {
                    scope.closePopup();
                    bwsNotificationService.error('Oops! Please try modifying your booking again');
                }
            }

            function setDeliveryTypeAndDate() {
                const options = deliveryService.hideAsapOption && scope.windowData.selectedOption.deliveryType === 'ASAP'
                    ? scope.firstAvailableWindow
                    : scope.windowData.selectedOption;

                let windowTime;
                let windowRange;

                if (options.windowTime) {
                    windowTime = !options.windowTime.StartTime ? options.windowTime : null;
                    windowRange = options.windowTime.StartTime ? options.windowTime : null;
                }

                /**
                 * Payload to send to the server when setting a delivery time
                 * @type {{WindowDate: null, WindowTime: *, WindowRange: *, bookingRef: string, DeliveryType: null}}
                 */
                const dto = !scope.isModifying.mode
                    ? options.deliveryType === 'ASAP' && !deliveryService.hideAsapOption
                        ? { DeliveryType: options.deliveryType }
                        : {
                            DeliveryType: options.deliveryType,
                            WindowDate: options.windowDate,
                            WindowTime: windowTime,
                            WindowRange: windowRange
                        }
                    : {
                        WindowDate: options.windowDate,
                        WindowTime: windowTime,
                        WindowRange: windowRange,
                        bookingRef: scope.modifyingBookingRef,
                        DeliveryType: options.deliveryType
                    };

                scope.savingDeliveryTimes = true;

                //clear the delivery times
                deliveryService.selectedDeliveryDateAndTime = {};

                if (options === scope.firstAvailableWindow) {
                    deliveryService.sendAnalyticFirstAvailableWindow('Checkout - Step 1');
                }

                if (scope.isModifying.mode) {
                    // Modifying delivery time for an existing booking
                    deliveryService.modifyDeliveryBooking(dto)
                        .then(function (res) {
                            _handleSavedDeliveryTimes(res.plain(), dto);
                        }, function () {
                            _handleErrorDeliveryTimes();
                        });
                } else {
                    // Setting delivery time in checkout
                    deliveryService.setDeliveryTypeAndDate(dto)
                        .then(function (res) {
                            const isCaptureRecipientInfoRequired = res.IsCaptureRecipientInfoRequired || false;
                            deliveryService.setIsRecipientIdCheckRequired(isCaptureRecipientInfoRequired);
                            scope.idVerificationChange(res.IsIdVerificationRequired);
                            _handleSavedDeliveryTimes(res, dto);
                        });
                }
            }

            scope.$watch('windowData.selectedOption', function (options) {
                if (typeof options !== 'undefined') {
                    if ((options.deliveryType === 'DateTime' && options.windowDate !== null && options.windowTime !== null)
                        || options.deliveryType === 'ASAP') {
                        setDeliveryTypeAndDate();
                    }
                } else {
                    return false;
                }
            }, true);

            scope.$watch('deliveryService.timeTable', loadTimeTable, true);

            scope.$watch('storePicker.store.FulfilmentStoreID', function (newVal, oldVal) {
                if (newVal !== '' && oldVal !== newVal && oldVal !== undefined && storePickerService.fulfilmentMethod === 'Delivery') {
                    deliveryService.getDeliveryWindows();
                } else {
                    return false;
                }
            }, true);

        },
        template: require('./delivery-timetable-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/delivery/delivery-timetable-directive.js
 **/